const domains = [
  {
    number: '01',
    title: 'Conseil en gestion',
    description:
      "Organisation et structuration de l'activité pour une meilleure performance opérationnelle et une gestion efficace au quotidien.",
  },
  {
    number: '02',
    title: "Stratégie d'entreprise",
    description:
      "Aide à la prise de décision stratégique pour le développement, la croissance et la pérennité de votre entreprise.",
  },
  {
    number: '03',
    title: 'Optimisation des activités',
    description:
      "Analyse des processus existants et mise en place d'améliorations concrètes pour gagner en efficacité et compétitivité.",
  },
];

export default function DomainsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#1A2B4A] mb-3">
            Expertises
          </p>
          <h2 className="font-poppins text-3xl font-semibold text-[#1A2B4A]">
            Domaines d'intervention
          </h2>
          <div className="w-12 h-0.5 bg-[#1A2B4A] mx-auto mt-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {domains.map((domain, index) => (
            <div
              key={index}
              className="bg-[#F8F9FA] rounded-lg p-8 hover:-translate-y-1 transition-transform duration-300"
            >
              <span className="font-poppins text-5xl font-bold text-[#1A2B4A]/10 leading-none">
                {domain.number}
              </span>
              <h3 className="font-poppins text-lg font-semibold text-[#1A2B4A] mt-3 mb-3">
                {domain.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{domain.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
